import AdminBar from '../components/sections/AdminBar/AdminBar';
import Navbar from '../components/sections/Navbar/Navbar';
import Promo from '../components/sections/Promo/Promo';
import Footer from '../components/sections/Footer/Footer';

export default function Layout(content, conference = {}) {

    return `
		${AdminBar()}
        ${Navbar()}
       
        <main>
            ${content}
        </main>
 
        ${Footer()}
    `;

}
